import * as ents from '@attain-apps/entities'
import exceljs from 'exceljs'

/**
 * @see {@link exceljs.ValueType}
 */
export import ValueType = exceljs.ValueType

/**
 * Converts the given {@link ents.core.common.value.types.Type} to an Excel
 * {@link ValueType}
 */
export function convertValueType(
  type: ents.core.common.value.types.Type | undefined,
): ValueType {
  switch (type) {
    case ents.core.common.value.types.Intrinsic.Currency:
    case ents.core.common.value.types.Intrinsic.Percent:
    case ents.core.common.value.types.Intrinsic.Integer:
    case ents.core.common.value.types.Intrinsic.Decimal:
      return ValueType.Number
    case ents.core.common.value.types.Intrinsic.Date:
      return ValueType.Date
    case ents.core.common.value.types.Intrinsic.Text:
      return ValueType.String
    default:
      // We default to just displaying the value as a string
      return ValueType.String
  }
}
